/**
 * @file sort.ts
 *
 * @fileoverview Exports sorting util functions.
 */
import { Maybe } from '~/jobiqo/types/types';

type SortableByWeight = unknown & { weight?: Maybe<number> | undefined };

/**
 * Sorts arguments by their weight property.
 * @param {SortableByWeight} a
 * @param {SortableByWeight} b
 * @returns
 * Compare function that compares by weight property.
 */
export function sortByWeight(a: SortableByWeight, b: SortableByWeight) {
  const isDefined = (val) => val !== undefined && val !== null;

  if (isDefined(a) && isDefined(b)) {
    return a.weight! > b.weight! ? 1 : -1;
  }

  return 0;
}
